import React from "react";
import PropTypes from "prop-types";

import ShareImageToFacebook from "core/ShareImageToFacebook";
import ShareImageToTwitter from "core/ShareImageToTwitter";

import { Container } from "./styles";

import { contentTypes } from "core/props";

const ShareSocials = ({
    spaceBetweenIcons = "0.8125rem",
    creatorName,
    imageType,
    permalinkPath,
    socialIconHeight,
    socialIconWidth,
    socialIconColor
}) => {
    const iconProps = {
        creatorName,
        imageType,
        permalinkPath,
        height: socialIconHeight,
        width: socialIconWidth,
        color: socialIconColor
    };

    return (
        <Container spaceBetweenIcons={spaceBetweenIcons}>
            <ShareImageToFacebook {...iconProps} />
            <ShareImageToTwitter {...iconProps} />
        </Container>
    );
};

ShareSocials.propTypes = {
    spaceBetweenIcons: PropTypes.string,
    creatorName: PropTypes.string.isRequired,
    imageType: PropTypes.oneOf(contentTypes).isRequired,
    permalinkPath: PropTypes.string.isRequired,
    socialIconHeight: PropTypes.number,
    socialIconWidth: PropTypes.number,
    socialIconColor: PropTypes.string
};

export default ShareSocials;
